import { MileageUnit } from './MaintenanceRecord.interface';

export interface TyreMaintenanceRecord {
    Id?: string | null;
    Id_2?: string | null;

    EventType: TyreMaintenanceType;
    Date: string;
    AxleCode: SingleReplacementPosition[];

    Season: SeasonType | undefined;
    Brand: string | undefined;
    Model: string | undefined;
    Width: string | undefined;
    Series: string | undefined;
    Radii: string | undefined;
    SpeedIndex: string | undefined;
    LoadIndex: string | undefined;
    IsAntiFlat: boolean | undefined;
    DidWeAlignTyres: boolean | undefined;
    DidWePermuteTyres: boolean | undefined;
    DotCode?: string | undefined;

    Season_2?: SeasonType | undefined;
    Brand_2?: string | undefined;
    Model_2?: string | undefined;
    Width_2?: string | undefined;
    Series_2?: string | undefined;
    Radii_2?: string | undefined;
    SpeedIndex_2?: string | undefined;
    LoadIndex_2?: string | undefined;
    IsAntiFlat_2?: boolean | undefined;
    DidWeAlignTyres_2?: boolean | undefined;
    DidWePermuteTyres_2?: boolean | undefined;
    DotCode_2?: string | undefined;

    OdometerReading: number;
    MileageUnit: MileageUnit;

}

export enum TyreMaintenanceType {
    REPLACEMENT = 0,
    ALIGNMENT = 2,
    ROTATION = 1
}


export enum SingleReplacementPosition {
    FRONT_LEFT = "L-0",
    FRONT_RIGHT = "R-0",
    BACK_LEFT = "L-1",
    BACK_RIGHT = "R-1",
}

export enum SeasonType {
    SUMMER = 0,
    WINTER = 1,
    ALL_SEASON = 2,
}

export interface PermutationRecord {
    OriginAxis: string;
    DestinationAxis: string;
}

export interface TyreMaintenanceRecordRequest {
    TyreRecord: TyreMaintenanceRecord,
    Permutations?: PermutationRecord[] | null;
}